import React, { useState } from 'react';

import { DATA_TABLE_SOURCE_SUNSETUP_LISTING_ORDERS } from 'common/dataTableConstants';

import {
  JOB_ORDER_STATUS_ACCEPTED,
  JOB_ORDER_STATUS_ASSIGNED,
  JOB_ORDER_STATUS_CREATED,
  JOB_STATUS_CANCELLED,
  JOB_STATUS_CREATED,
  JOB_STATUS_FAILED,
} from 'common/jobConstants';

import { LISTING_ACTIVE_STATUS_LIST } from 'common/listingConstants';

import { MARKETING_PARTNER_LISTING_ACTIVE_STATUSES } from 'common/marketingPartnerListingConstants';

import SrDataTableConnected from 'client/components/SrDataTableConnected';
import SrSunSetupOrderItem from 'client/components/SrSunSetupOrdersOverview/SrSunSetupOrderItem';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_BLUE_DARK_NAVY,
  SR_BUTTON_THEME_ADOBE_BLUE_DARK_NAVY_OUTLINE,
} from 'client/components/SrButton/SrButton';

import './SrSunSetupOrdersOverview.less';

const FILTER_ALL_OPEN_ORDERS = 'FILTER_ALL_OPEN_ORDERS';
const FILTER_GOING_TO_MARKET = 'FILTER_GOING_TO_MARKET';

const SUNSETUP_FILTERS = [
  {
    key: FILTER_ALL_OPEN_ORDERS,
    title: 'All Open Orders',
    viewSettings: {
      filter: {
        earliestJobOrderStatus: [
          JOB_ORDER_STATUS_CREATED,
          JOB_ORDER_STATUS_ASSIGNED,
          JOB_ORDER_STATUS_ACCEPTED,
        ],
      },
      sort: {
        earliestJobOrderDueDate: 'asc',
      },
    },
  },
  {
    key: FILTER_GOING_TO_MARKET,
    title: 'Going to Market',
    viewSettings: {
      filter: {
        earliestJobStatus: [JOB_STATUS_CREATED, JOB_STATUS_FAILED, JOB_STATUS_CANCELLED],
        listingStatus: LISTING_ACTIVE_STATUS_LIST,
        marketingPartnerStatus: MARKETING_PARTNER_LISTING_ACTIVE_STATUSES,
      },
      sort: {
        promiseDate: 'desc',
      },
    },
  },
];

const SrSunSetupOrdersOverview = ({ driversByMarketId }) => {
  const [activeFilter, setActiveFilter] = useState(FILTER_ALL_OPEN_ORDERS);

  const handleFilterUpdate = ({ viewSettings, filterKey }) => {
    const filterMatch = SUNSETUP_FILTERS.find(({ key }) => key === filterKey);
    viewSettings.update(filterMatch.viewSettings);
    setActiveFilter(filterMatch.key);
  };

  return (
    <SrDataTableConnected
      dataSource={DATA_TABLE_SOURCE_SUNSETUP_LISTING_ORDERS}
      rootViewId={DATA_TABLE_SOURCE_SUNSETUP_LISTING_ORDERS}
      initialViewSettings={SUNSETUP_FILTERS[0].viewSettings}
      itemsPropName="listings"
      count={30}
    >
      {({ listings, viewSettings, onInfiniteScrollWrapperRef, reloadItems }) => {
        return (
          <div styleName="SrSunSetupOrdersOverview" ref={onInfiniteScrollWrapperRef}>
            <div styleName="filtersSection">
              {SUNSETUP_FILTERS.map((filter) => (
                <SrButton
                  key={filter.key}
                  theme={
                    activeFilter === filter.key
                      ? SR_BUTTON_THEME_ADOBE_BLUE_DARK_NAVY
                      : SR_BUTTON_THEME_ADOBE_BLUE_DARK_NAVY_OUTLINE
                  }
                  onClick={() =>
                    handleFilterUpdate({
                      viewSettings,
                      filterKey: filter.key,
                    })
                  }
                >
                  {filter.title}
                </SrButton>
              ))}
            </div>
            <table styleName="ordersTable">
              <thead>
                <tr>
                  <th>Promise Date</th>
                  <th>Address</th>
                  <th>Market</th>
                  <th>Partner</th>
                  <th>Driver</th>
                  <th>Status</th>
                  <th>Due</th>
                  <th>Jobs</th>
                  <th>Order Id</th>
                </tr>
              </thead>
              <tbody>
                {(listings || []).map((listing) => (
                  <SrSunSetupOrderItem
                    key={listing.id}
                    listing={listing}
                    drivers={driversByMarketId[listing.marketId] || []}
                    reloadDataTable={(listingId) => {
                      reloadItems({
                        count: 1,
                        filter: { id: listingId },
                      });
                    }}
                  />
                ))}
              </tbody>
            </table>
          </div>
        );
      }}
    </SrDataTableConnected>
  );
};

SrSunSetupOrdersOverview.displayName = 'SrSunSetupOrdersOverview';

export default SrSunSetupOrdersOverview;
